/* =========================

  select btn

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";

import { useSelector,useDispatch } from "react-redux";
import { useEffect } from 'react';


/* -------------------------

  component

---------------------------- */
function BtnSelect( props ) {
  // let sum = Number(useSelector((state)=>state.sum));
  const count = useSelector((state)=>state.count);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.questionNum === count){
      setTimeout(() => {
        document.querySelector(`#${props.id}+label`).classList.add("isFadeIn");
      }, 500*props.num);
    }
  }, [props.id,props.num,props.questionNum,count]);

  let cancelFlag = 0;
  const doActionFunc = (e) => {
    if (cancelFlag === 0) {
      // 都度合計
      // let getSum = sum + Number(props.value);
      // dispatch({type:"ADD_SUM",payload:getSum});

      e.currentTarget.closest(".question").classList.add("isFadeOut");
      setTimeout(() => {
        e.target.closest(".question").classList.add("isDisplayNone");
        dispatch({type:"ADD_COUNT",payload:count + 1});
      }, 1000);

      cancelFlag = 1;
    }
    setTimeout(function () {
      cancelFlag = 0;
    }, 300);
  }

  return (
    <>
      <div className="c-btn_select">
        <StyledInput type="radio" name={props.name} value={props.value} id={props.id} autoComplete="off" onChange={doActionFunc} data-answer={props.num} />
        <StyledLabel htmlFor={props.id}><span className="c-btn_select__inner c-font_f--km">{props.children}</span></StyledLabel>
      </div>
    </>
  );
}

export default BtnSelect;

/* -------------------------

  styled

---------------------------- */
const StyledInput = styled.input`
  display: none;
`;

const StyledLabel = styled.label`
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  height: 100%;
  padding: 11px 10px;
  background-color: #ee7300;
  border: 4px solid #ee7300;
  border-radius: 50vw;
  color: #ffffff;
  font-size: 2.8rem;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  &.isFadeIn {
    &:hover{
      background-color: #ffffff;
      color: #ee7300;
    }
  }
	@media ${break_point_sp} {
    width: 100%;
    font-size: calc(48 / 750 * 100vw);
	}
`;
